import Saving, { SavingToCreate, SavingToUpdate } from "../models/Saving";
import { Observable } from "rxjs";
import { HttpCommunicator, Container } from "@ivorobioff/shared";
import { SingleAmountUpdate } from '../models/Entry';


export class SavingService {

  private http: HttpCommunicator;

  constructor(container: Container) {
    this.http = container.get('https');
  }

  getAll(): Observable<Saving[]> {
    return this.http.get('/savings');
  }

  getAllAsync(): Promise<Saving[]> {
    return new Promise((resolve, reject) =>
      this.getAll().subscribe(resolve, reject));
  }

  updateAmount(id: string, update: SingleAmountUpdate): Observable<Saving> {
    return this.http.patch('/savings/' + id, update);
  }

  updateAmountAsync(id: string, update: SingleAmountUpdate): Promise<Saving> {
    return new Promise((resolve, reject) =>
      this.updateAmount(id, update).subscribe(resolve, reject));
  }

  update(id: string, updates: SavingToUpdate): Observable<Saving> {
    return this.http.patch('/savings/' + id, updates);
  }

  create(saving: SavingToCreate): Observable<Saving> {
    return this.http.post('/savings', saving);
  }

  createAsync(saving: SavingToCreate): Promise<Saving> {
    return new Promise((resolve, reject) =>
      this.create(saving).subscribe(resolve, reject));
  }

  remove(id: string): Observable<void> {
    return this.http.delete('/savings/' + id);
  }
}